import React, { useMemo } from 'react';
import { bool, number, string, shape, arrayOf } from 'prop-types';
import { chunk } from 'lodash';
import styles from './styles/styles.module.scss';
import River from '../../../shared/River';
import ActivitySuitabilityImage from './ActivitiySuitabilityImage';
import { DESKTOP_BREAKPOINT } from '../../../../utils/constants/breakpoints';

const ARROW_STYLES = { next: styles.next, previous: styles.prev };

const ActivitySuitabilityRiver = ({ activities, mobileBrowser, windowWidth, languageRegionCode }) => {
  const mobileColumns = useMemo(() => {
    return mobileBrowser || (windowWidth && windowWidth <= DESKTOP_BREAKPOINT);
  }, [mobileBrowser, windowWidth]);

  const chunkedActivities = useMemo(() => {
    const divider = mobileColumns ? 3 : 2;

    return chunk(activities, divider);
  }, [mobileColumns]);

  const slickSettings = useMemo(() => {
    return { slidesToShow: 3, lazyLoad: 'progressive', slidesToScroll: 3, speed: 750 };
  }, [mobileColumns]);

  return (
    <River useSlick={windowWidth >= 1270} className={styles.riverClass} slickSettings={slickSettings} arrowStyles={ARROW_STYLES}>
      {chunkedActivities.map(group => {
        return (
          <div className={mobileColumns ? styles.mobileColumns : styles.columns} key={group[0].title}>
            {group.map(activity => {
              return (
                <ActivitySuitabilityImage
                  url={activity.explore_url}
                  src={activity.photo_urls.square.two}
                  title={activity.title}
                  key={activity.title}
                  languageRegionCode={languageRegionCode}
                />
              );
            })}
          </div>
        );
      })}
    </River>
  );
};

ActivitySuitabilityRiver.propTypes = {
  mobileBrowser: bool,
  windowWidth: number,
  activities: arrayOf(
    shape({
      title: string,
      explore_url: string,
      photo_urls: shape({
        square: shape({
          two: string,
          three: string
        })
      })
    })
  ).isRequired,
  languageRegionCode: string
};

ActivitySuitabilityRiver.defaultProps = {
  mobileBrowser: true,
  windowWidth: null,
  languageRegionCode: 'en-US'
};

export default ActivitySuitabilityRiver;
